export function ensureProtocol(url) {
  return !url.match(/^https?:\/\//) && url.length > 0 && !('http://'.includes(url) || 'https://'.includes(url))
    ? `https://${url}`
    : url;
}
